export const windowsResize = {
  data () {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created () {
    window.addEventListener('resize', this.funcHandleResize);
    this.funcHandleResize();
  },
  destroyed () {
    window.removeEventListener('resize', this.funcHandleResize);
  },
  methods: {
    funcHandleResize () {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
};
